import React, { useEffect } from "react";
import "../styles/ads.scss";
import useClientConfig from "../config/careers/clientConfig";

const AdsPlaceholder = ({ placement, clientConfig, styleClass } : { placement: string, clientConfig: any, styleClass?: string }) => {

    const { clientAssetsLink } = useClientConfig();

    const adConfig = clientConfig?.clientSiteSettings?.adsConfig?.adPlacements?.find(
        (ad : any) => ad.id === placement
    );

    const type = adConfig?.type || "image";

    useEffect(() => {
        if (type === "gtm" && adConfig?.gtmSlotId) {
            (window as any).googletag = (window as any).googletag || { cmd: [] };
            (window as any).googletag.cmd.push(() => {
                (window as any).googletag.display(adConfig.gtmSlotId);
            });
        }
    }, [type, adConfig?.gtmSlotId]);

    if (!clientConfig?.clientSiteSettings?.adsConfig?.enabled || !adConfig?.enabled) {
        return null;
    }

    const renderContent = () => {
        if (type === "image") {
            const image = adConfig.imgUrl ? (
                <img src={clientAssetsLink + adConfig.imgUrl} className="img-fluid" alt={`ad ${placement}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            ) : null;
            return adConfig.linkUrl ? (
                <a href={adConfig.linkUrl} target="_blank" rel="noopener noreferrer">{image}</a>
            ) : image;
        }

        if (type === "gtm") {
            return <div id={adConfig.gtmSlotId}></div>;
        }

        if (type === "script") {
            return <div dangerouslySetInnerHTML={{ __html: adConfig.scriptHtml }} />;
        }

        return null;
    };

    return (
        <div
            className={`ad-container ${styleClass}`}
            data-placement={placement}
            style={{
                maxWidth: adConfig.size.width,
                width: "100%",
                height: adConfig.size.height
            }}
        >
            <div id={`ad-${placement}`}>
                {renderContent()}
            </div>
        </div>
    );
};

export default AdsPlaceholder;